import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AlarmIcon from '@material-ui/icons/Alarm';
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>Faça sua Escolha</h2>
          <br/>
          <h3 className={classes.description}>O aplicativo Tac veio para revolucionar a mobilidade urbana.</h3>
          <h5 className={classes.description}>
          Nosso plano de trabalho tem a visão de favorecer tanto o motorista quanto ao passageiro. Nossa base inicial é não cobrar comissão dos motoristas dando maior flexibilidade para negociação das corridas.
          </h5>
          <h3 className={classes.description}>A regra é bem simples:</h3>
          <h4 className={classes.description}> "Em outros aplicativos o motorista paga de 25 a 40% de comissão".</h4>
          <h5 className={classes.description}>
          No Tac o motorista não paga comissão, então mesmo que o passageiro oferte um valor 10% menor que o valor de outro App, mesmo assim tanto o motorista quanto o passageiro saem ganhando.
          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Carro, Mototáxi ou Entregas"
              description="Nosso aplicativo conta com os mais responsáveis motoristas, são pessoas com grande experiência e apaixonadas pelo que fazem. Eles são mães e pais, alunos e professores, veteranos vizinhos, amigos, nossos parceiros do dia-a-dia."
              icon={EmojiTransportationIcon}
              iconColor="danger"
              vertical
            />
            <p className={classes.description}>Viagem para o trabalho, entregas, passeios pela cidade, ir para a faculdade, aquela balada noturna, aonde quer que você vá, conte com o Modelo Transporte para uma viagem segura.</p>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Agilidade, praticidade e segurança na palma da mão"
              description="A maneira mais inteligente de se locomover. Um toque e um carro ou moto vai até você. Seu motorista sabe exatamente para onde ir. E você pode pagar com dinheiro ou cartão."
              icon={AlarmIcon}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Segurança"
              description="O primeiro app da categoria a exigir Reconhecimento Facial dos passageiros. Trazendo mais segurança aos motorista."
              icon={VerifiedUser}
              iconColor="success"
              vertical
              facial
            />
            <p className={classes.description}>Possuímos também o botão de pânico e compartilhar localização. </p>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
